<template>
  <div class="g_switch-2">
    <!-- 纵向排列三列 type = 1 => 文字 + rate + 选择 -->
    <!-- 纵向排列三列 type = 2 => 数字(1-10) || 文字 + rate + 选择 -->
    <!-- 纵向排列二列 type = 3 => 数字(1-20) || 文字 + rate + 选择 -->
    <!-- 纵向排列二列 type = 4 => rate + 选择 -->

    <h3 class="tc-b">
      <span class="t_wei">{{title}}</span>
    </h3>
    <div class="g_switch-wrap">
      <v-switch-item
        class="switch-2"
        :chip="chip"
        v-for="(item, index) in list"
        :type="verticalType"
        :key="'item' + index"
        :item="item"
        :isSelectAll="isSelectAll"
      />
    </div>
  </div>
</template>

<script>
// 纵向-单列
import VSwitchItem from "../switch-item/g_switch-item1";
import Vue from "../../../utils/bus";
export default {
  name: "g_switch-1",
  components: {
    VSwitchItem
  },
  props: {
    chip: String,
    verticalType: {
      type: Number,
      default: 1
      // 1 => 三列 => 文字 + rate + 选择
      // 2 => 三列 => 数字（1-10）|| 文字 + rate + 选择
      // 3 => 三列 => 数字（1-20）|| 文字 + rate + 选择
      // 4 => 二列 => rate + 选择
    },
    title: {
      type: String,
      default: "冠、亚军和"
    },
    list: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      balls: Array.from({ length: 20 }, (item, index) => index + 1),
       isSelectAll: false,
    };
  },
  created() {
    Vue.$on("changSelect", (item) => {
      if(item == this.title||item=="all"){
        if(this.isSelectAll){
          this.isSelectAll=false;
          //Vue.$emit("resetInput");
        }else {
          this.isSelectAll=true;
        }
      }
    });
    Vue.$on("reset",()=>{
      this.isSelectAll=false;
    });
    Vue.$on("resetDefault",()=>{
      this.isSelectAll=false;
    })
  }
};
</script>

<style scoped lang="stylus">
$border-color = #E6E6E6;

.g_switch-2 {
  h3 {
    width: 100%;
    height: 26px;
    border: 1px solid $border-color;
    font-size: 13px;
    box-sizing: border-box;
    text-align: center;
    font-weight: bold;
    line-height: 26px;
    margin-bottom: 2px;
    background: linear-gradient(#FEFEFE, #F0F0F0);

    > span {
      display: inline-block;
      position: relative;

      &:before, &:after {
        height: 1px;
        top: 50%;
        display: block;
        content: '';
        position: absolute;
      }

      &:before {
        left: -40px;
      }

      &:after {
        right: -40px;
      }
    }
  }

  .g_switch-wrap {
    overflow: hidden;
    font-size: 13px;
    border-top: 1px solid $border-color;
    border-right: 1px solid $border-color;

    .switch-2 {
      box-sizing: border-box;
      border-left: 1px solid $border-color;
    }

    switch-2:first-child {
      border-top: 1px solid $border-color;
    }

    .switch-1:last-child {
      box-sizing: border-box;
      border-right: 1px solid $border-color;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/c_game-switch/switch-list/g_switch-2.vue